<template>
  <iInput
    ref="input"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :class="$style.input"
    @input="$emit('input', $event)"
    @on-input-change="$emit('change', $event)"
    @on-focus="$emit('focus', $event)"
    @on-blur="$emit('blur', $event)"
  >
    <slot
      slot="append"
      name="append"/>
  </iInput>
</template>

<script>
export default {
  name: 'GdlInput',
  model: { prop: 'value', event: 'input' },
  $_veeValidate: {
    value() {
      // allow changed flag to instantly update
      return this.$refs.input.$refs.input.value;
    },
  },
  props: {
    value: { type: [String, Number], default: '' },
    type: {
      type: String,
      validator: value => ['text', 'password', 'url', 'email', 'date'].includes(value),
      default: 'text',
    },
    placeholder: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" module>
.input {
  input[readonly] {
    border-color: #dddee1;
    box-shadow: unset;
    cursor: auto;

    &::placeholder {
      color: transparent;
    }
  }
}
</style>
